/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Checkbox, Icon, Tooltip } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import '../ColumnsFilter.css';

const TOOLTIP_DELAY_IN_MS_TILE = 500;

function CertColsSortableItem({
  option,
  handleChange,
  getTooltipText,
  getTooltipTrigger,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: option.value });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className='ColumnsFilter-subItems'>
      {option?.isChecked ? (
        <div className='ColumnsFilter-dragger' {...attributes} {...listeners}>
          <Tooltip
            isPortalEnabled
            text='Drag to Reorder'
            trigger={
              <Icon
                kind='DragVertical'
                color='neutral-1000'
                size='smallMedium'
              />
            }
          />
        </div>
      ) : (
        <span className='ColumnsFilter-draggerFiller' />
      )}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/label-has-associated-control */}
      <label
        htmlFor={option?.value}
        className='ColumnsFilter-checkBox'
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleChange(option?.value);
          }
        }}>
        <Checkbox
          id='columns-sortable-checkbox'
          name={option?.value}
          isChecked={option?.isChecked}
          onChange={() => handleChange(option?.value)}
          dataTestId='checkbox-no-hovereffect'
        />
        <Tooltip
          openDelay={TOOLTIP_DELAY_IN_MS_TILE}
          text={getTooltipText(option)}
          maxWidth='20rem'
          trigger={getTooltipTrigger(option)}
        />
      </label>
    </div>
  );
}

CertColsSortableItem.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string,
    isChecked: PropTypes.bool,
    label: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  getTooltipText: PropTypes.func.isRequired,
  getTooltipTrigger: PropTypes.func.isRequired,
};

export default CertColsSortableItem;
